import { render, staticRenderFns } from "./ModalSignAttachment.vue?vue&type=template&id=3ecdde81&"
import script from "./ModalSignAttachment.vue?vue&type=script&lang=js&"
export * from "./ModalSignAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ecdde81')) {
      api.createRecord('3ecdde81', component.options)
    } else {
      api.reload('3ecdde81', component.options)
    }
    module.hot.accept("./ModalSignAttachment.vue?vue&type=template&id=3ecdde81&", function () {
      api.rerender('3ecdde81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalSignAttachment.vue"
export default component.exports